module.exports = __webpack_public_path__ + "img/shell_logo.ee5fe4bc.png";